import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import React from 'react';
import { useHistory } from "react-router-dom";
import Page from "../../containers/Page/Page";
import { useLoading } from '../../hooks/loading';
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IAcessorio {
    modelo_acessorio: string;
    nome: string;
}

function Grupos() {

    //Hooks
    const history = useHistory();

    //Loading
    const { startLoading, stopLoading, isLoading } = useLoading();

    //States
    const [error, setError] = React.useState<string>('');
    const [acessorios, setAcessorios] = React.useState<IAcessorio[]>([]);

    //Effects
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar acessórios.
     * @param page 
     * @return void
     */
    async function handleFetch() {
        startLoading('main');
        try {
            const response = await api.get('grupos');
            setAcessorios(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        } finally {
            stopLoading('main');
        }
    }

    return (
        <Page error={error} loading={isLoading('main')}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Grupos / Acessórios
                </Typography>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => history.push('/grupos/create')}>
                    Novo Atrelamento
                </Button>
            </Page.Title>
            <Page.Section>
                <Page.Content>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Acessório</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {acessorios && acessorios.length > 0 ? acessorios.map((acessorio) => (
                                    <TableRow
                                        key={acessorio.modelo_acessorio}
                                        hover={true}
                                        onClick={() => history.push(`/grupos/${acessorio.modelo_acessorio}`)}
                                    >
                                        <TableCell>{acessorio.nome}</TableCell>
                                    </TableRow>
                                )) :
                                    <TableRow>
                                        <TableCell colSpan={2}>Nenhum atrelamento cadastrado.</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Page.Content>
            </Page.Section>
        </Page >
    );
}

export default Grupos;